import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const UnfilledButton = ({
  uppercase,
  fontSize,
  text,
  handleClick,
  disabled,
  children,
}) => (
  <S.UnfilledButton
    isUppercase={uppercase}
    fontSize={fontSize}
    onClick={handleClick}
    disabled={disabled}
  >
    {children || text}
  </S.UnfilledButton>
);

export default UnfilledButton;

UnfilledButton.defaultProps = {
  uppercase: true,
  fontSize: 14,
  handleClick: () => {},
  disabled: false,
  children: undefined,
};

UnfilledButton.propTypes = {
  uppercase: PropTypes.bool,
  fontSize: PropTypes.string,
  text: PropTypes.string.isRequired,
  handleClick: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.func,
    PropTypes.string,
    PropTypes.number,
  ]),
};
